module.exports = __webpack_public_path__ + "static/media/litho-4.60d86914.jpg";